function f(f,a,e,n){f._m(a),f.o(a,"SkeletonShape",()=>f.f(o));var o=f.i(e("dbdcffba"));}